import React from "react";
import { NavLink } from "react-router-dom";
import { checkPermission } from "../../../../utils/Authorization/authorization";

import "./KeyNavigation.component.scss";

interface keyNavigationProps {
    altMenu?: any;
    children?: any;
}

export const KeyNavigation = (props: keyNavigationProps) => (
    <div className="key-topbar">
        <div className="container">
            <div className="row">
                <div className="col-12">
                    {!props.altMenu && (
                        <div className="sub-menu">
                            {checkPermission("generate_key") && (
                                <NavLink
                                    exact
                                    activeClassName="is-active"
                                    to="/configuration-key"
                                >
                                    Generate
                                </NavLink>
                            )}

                            {checkPermission("history_key") && (
                                <NavLink
                                    exact
                                    activeClassName="is-active"
                                    to="/configuration-key/history/"
                                >
                                    History
                                </NavLink>
                            )}
                        </div>
                    )}
                    {props.altMenu}
                    {props.children}
                </div>
            </div>
        </div>
    </div>
);
